export default {
	GOOGLE_SLIDES_CANNOT_COPY_PASTE_SLIDES: 'TopInformationGSCannotCopyPasteSlides',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_FAILED: 'InteractiveVideoUploadVideoFailed',
}
